/**
 * url-utils.ts
 *
 * Pure URL helpers shared by the component and unit tests.
 * No Vite / browser globals — safe to import in any Node.js test runner.
 */

/**
 * Rewrites a URL so that the leading `connectBase` segment is replaced by
 * `connectUrl`. Used when the host app passes a `connect-url` attribute to
 * redirect Connect-app links to a different host (e.g. local dev or staging).
 *
 * Returns the URL unchanged if:
 *  - `url` is null / empty
 *  - `connectUrl` is empty (no override configured)
 *  - `connectBase` is empty (compiled-in env var was missing)
 *  - the URL does not start with `connectBase` (non-Connect link)
 */
export function resolveConnectUrl(
    url: string | null,
    connectUrl: string,
    connectBase: string,
): string | null {
    if (!url || !connectUrl || !connectBase) return url
    if (url.startsWith(connectBase)) {
        return connectUrl + url.slice(connectBase.length)
    }
    return url
}


/**
 * Resolves the effective URL for the M2Mx nav item based on the user's record type.
 * Members and Spouse/Partners navigate to their profile page; all others go to the overview.
 */
export function resolveM2mxUrl(
    recordTypeName: string | undefined,
    profileUrl: string,
    overviewUrl: string,
): string {
    if (!recordTypeName) return overviewUrl
    const t = recordTypeName.toLowerCase()
    return (t === 'member' || t === 'spouse/partner') ? profileUrl : overviewUrl
}
